export enum ERoleIsSystem {
	System = 'System',
	NotSystem = 'NotSystem',
}

export const ROLE_IS_SYSTEM_LABEL_MAP: Record<ERoleIsSystem, string> = {
	[ERoleIsSystem.System]: `role_is_system.${ERoleIsSystem.System}`,
	[ERoleIsSystem.NotSystem]: `role_is_system.${ERoleIsSystem.NotSystem}`
}